import { DirectiveOptions } from 'vue';

const directive: DirectiveOptions = {
    inserted(el: HTMLElement) {
        const elTarget = document.getElementById(el.getAttribute('data-target') || '');
        let pageNumber = 0;

        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (elTarget) {
                if (el.hasAttribute('data-toggle-paged')) {
                    elTarget.querySelectorAll('[data-hidden="1"][data-page="' + pageNumber + '"]').forEach((item) => {
                        item.classList.toggle('d-none');
                    });
                    pageNumber++;
                } else {
                    elTarget.querySelectorAll('[data-hidden="1"]').forEach((item) => {
                        item.classList.toggle('d-none');
                    });
                }

                if (el.parentElement
                    && elTarget.querySelectorAll('.d-none').length === 0) {
                    el.parentElement.classList.toggle('d-none');
                }
            }
        });
    }
};

export default directive;
